export const INIT_SCENARIOS = 'INIT_SCENARIOS';
export const UPDATE_SCENARIO = 'UPDATE_SCENARIO';
export const DELETE_SCENARIO = 'DELETE_SCENARIO';
export const ADD_SCENARIO = 'ADD_SCENARIO';

export default { INIT_SCENARIOS, UPDATE_SCENARIO, DELETE_SCENARIO, ADD_SCENARIO };
